import { SignupForm } from 'mk2/apps/users/components/SignupForm';
import { Props } from 'mk2/apps/users/containers/SignupIFrame/SignupIFramePage';
import React from 'react';
import styles from './SignupIFrame.mscss';

export default class SignupIFrame extends React.Component<Props> {

    private divElement: React.RefObject<HTMLDivElement> = React.createRef();

    public componentDidMount() {
        document.body.classList.add(styles.SignupIFrame__body);
        document.getElementById('page-content').classList.add(styles.SignupIFrame__pageContent);

        window.parent.postMessage({
            type: 'frameLoaded',
            height: this.divElement.current.clientHeight,
            width: this.divElement.current.clientWidth,
        }, '*');
    }

    public render() {
        const { onStoreEvent, query, simple, initialValues, onVerifySmsToken, onPrepareUploadPhotos,
                onSendSmsToken, currentValues, avatar } = this.props;

        return (
            <SignupForm
                onStoreEvent={onStoreEvent}
                query={query}
                simple={simple}
                iframe
                divRef={this.divElement}
                onSignup={this.handleSignup}
                initialValues={initialValues}
                currentValues={currentValues}
                onValidateInputs={this.handleValidateInputs}
                onVerifySmsToken={onVerifySmsToken}
                onSendSmsToken={onSendSmsToken}
                onPrepareUploadPhotos={onPrepareUploadPhotos}
                avatar={avatar}
            />
        );
    }

    private handleSignup = (values) => {
        const { query, onSignup } = this.props;
        onSignup(values, query, true, false);
    };

    private handleValidateInputs = (values) => {
        const { query, onValidateInputs } = this.props;
        onValidateInputs(values, query);
    };
}
